export default {
    COLOR_POINT: 'rgb(0,155,77)',
    COLOR_POINT_FILL: 'rgb(255,255,255)',
    COLOR_LANDSCAPE: '#FFAD00',
    COLOR_BORDERS: 'rgb(195,230,255)',
    COLOR_LINE: 'rgb(255,255,255)',
    COLOR_SELECTED_POINT: 'rgb(0,184,83)',

    COLOR_BROWN: 'rgb(139,69,19)',
    COLOR_BLACK: 'rgb(0,0,0)',
    COLOR_BLUE: 'rgb(77,109,155)',
    COLOR_LIGHT_BLUE: 'rgb(124,156,201)',
    COLOR_WHITE: 'rgb(255,255,255)',
    COLOR_WHITEY: 'rgb(240,240,240)',
    COLOR_GREEN: 'rgb(0,155,77)',
    COLOR_TOMATO: 'rgb(243,114,114)',

    CHART_COLORS: [
        '#E53935',
        '#1E88E5',
        '#5c54a4',
        '#87ceff',
        "#BF360C",
        "#3D5AFE",
        "#546E7A",
        "#512DA8",
        "#FF4081",
        "#0277BD",
        "#388E3C",
        "#F9A825",
        "#424242",
        "#42A5F5",
        "#6D4C41",
        "#3949AB",
        "#B71C1C",
        "#FFCA28",
        "#E65100",
        "#558B2F",
        "#6A1B9A",
        "#006064",
        "#AB47BC",
        "#C2185B",
    ]
};